<template>
  <div>
    <div v-if="intent">
      <v-layout class="mb-3">
        <v-flex class="text-xs-right">
          <v-btn
            v-if="isExist"
            outline
            color="primary"
            @click="$emit('onDeleteConnection');$emit('onCancel')"
          >
            <v-icon class="mr-2">delete</v-icon>Delete
          </v-btn>
        </v-flex>
      </v-layout>
      <div class="pa-2">
        Reply message
        <div class="form-control">
          <input type="text" v-model="intent.default_text" />
        </div>
        <div class="text-xs-center">
          <v-btn outline color="grey" @click="onCancel">{{ $t('cancel') }}</v-btn>
          <v-btn color="primary" depressed @click="onSave">{{ $t('Save') }}</v-btn>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['value'],
  data() {
    return {
      intent: null
    }
  },
  computed: {
    isExist() {
      var index = this.intent.connected_intents.findIndex(el => {
        return el.text == '{default}' && el.type == 'input'
      })
      return index != -1
    }
  },
  mounted() {
    this.intent = this.value
    this.cached_intent = JSON.stringify(this.intent)
  },
  methods: {
    onCancel() {
      this.intent = JSON.parse(this.cached_intent)
      this.$emit('input', this.intent)
      this.$emit('onCancel')
    },
    onSave() {
      this.$emit('input', this.intent)
      this.$emit('onSave', this.intent)
    }
  }
}
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/components/view/flow/DefaultManage.vue